module.exports = __webpack_public_path__ + "img/huiyi.bc148c52.png";